<div>
  
  <div mat-dialog-title>
    <mat-icon mat-dialog-close>close</mat-icon>
    <!--<h3>{{ 'warnings.title' | transloco }}</h3> !-->
  </div>
  <mat-dialog-content>
    <!--
    <p>
      {{ 'warnings.extraction.body' | transloco }}
    </p>
    <p [innerHTML]="'warnings.extraction.time' | transloco: { value: time }" ></p>
    --> 
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="cancel-button" (click)="dialog.closeAll()">{{ 'warnings.extraction.button' | transloco }}</button>
    <button class="full-button" (click)="downloadGeneratedFile()">{{ 'warnings.extraction.download' | transloco }}</button>
  </mat-dialog-actions>
</div>
